import { render, staticRenderFns } from "./TableFieldConfigurator.vue?vue&type=template&id=50374362"
import script from "./TableFieldConfigurator.vue?vue&type=script&lang=js"
export * from "./TableFieldConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports